"use client"

import type React from "react"

interface VCardFormProps {
  firstName: string
  lastName: string
  organization: string
  title: string
  email: string
  phone: string
  website: string
  address: string
  onFirstNameChange: (value: string) => void
  onLastNameChange: (value: string) => void
  onOrganizationChange: (value: string) => void
  onTitleChange: (value: string) => void
  onEmailChange: (value: string) => void
  onPhoneChange: (value: string) => void
  onWebsiteChange: (value: string) => void
  onAddressChange: (value: string) => void
}

const VCardForm: React.FC<VCardFormProps> = ({
  firstName,
  lastName,
  organization,
  title,
  email,
  phone,
  website,
  address,
  onFirstNameChange,
  onLastNameChange,
  onOrganizationChange,
  onTitleChange,
  onEmailChange,
  onPhoneChange,
  onWebsiteChange,
  onAddressChange,
}) => {
  return (
    <div className="form-group vcard-form">
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="vcard-firstname">First Name:</label>
          <input
            id="vcard-firstname"
            type="text"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            placeholder="First Name"
            className="text-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="vcard-lastname">Last Name:</label>
          <input
            id="vcard-lastname"
            type="text"
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            placeholder="Last Name"
            className="text-input"
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="vcard-organization">Organization:</label>
          <input
            id="vcard-organization"
            type="text"
            value={organization}
            onChange={(e) => onOrganizationChange(e.target.value)}
            placeholder="Company/Organization"
            className="text-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="vcard-title">Job Title:</label>
          <input
            id="vcard-title"
            type="text"
            value={title}
            onChange={(e) => onTitleChange(e.target.value)}
            placeholder="Job Title"
            className="text-input"
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="vcard-email">Email:</label>
          <input
            id="vcard-email"
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            placeholder="Email Address"
            className="text-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="vcard-phone">Phone:</label>
          <input
            id="vcard-phone"
            type="tel"
            value={phone}
            onChange={(e) => onPhoneChange(e.target.value)}
            placeholder="Phone Number"
            className="text-input"
          />
        </div>
      </div>

      <label htmlFor="vcard-website">Website:</label>
      <input
        id="vcard-website"
        type="url"
        value={website}
        onChange={(e) => onWebsiteChange(e.target.value)}
        placeholder="https://example.com"
        className="text-input"
      />

      <label htmlFor="vcard-address">Address:</label>
      <textarea
        id="vcard-address"
        value={address}
        onChange={(e) => onAddressChange(e.target.value)}
        placeholder="Street, City, State, ZIP, Country"
        className="text-input text-area"
        rows={2}
      />
    </div>
  )
}

export default VCardForm
